<template>
  <v-layout
    :title="$t('purchases_help.title')"
    :subtitle="$t('purchases_help.subtitle')"
  >
    <HelpPage :topics="topics" />
  </v-layout>
</template>


<script>
import VLayout from "@/layouts/Default";
import HelpPage from "@/components/HelpPage";

export default {
  components: {
    VLayout,
    HelpPage,
  },
  computed: {
    topics() {
      return [
        {
          title: this.$t("purchases_help.why.title"),
          text: this.$t("purchases_help.why.content"),
        },
        {
          title: this.$t("purchases_help.home.title"),
          text: this.$t("purchases_help.home.content"),
        },
        {
          title: this.$t("purchases_help.how.title"),
          text: this.$t("purchases_help.how.content"),
        },
        {
          title: this.$t("purchases_help.prices.title"),
          text: this.$t("purchases_help.prices.content"),
        },
        {
          title: this.$t("purchases_help.without.title"),
          text: this.$t("purchases_help.without.content"),
        },
      ];
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        purchases_help: {
          title: "My purchases",
          subtitle:
            "Shopping at Vooy Market is easy, convenient and safe",
          breadcrumb: "My purchases",
          why: {
            title: "Why shopping at Vooy Market?",
            content: "",
          },
          how: {
            title: "How to shop at Vooy Market?",
            content: "",
          },
          without: {
            title: "Can I shop without registering?",
            content: "",
          },
          home: {
            title: "Home delivery produts",
            content: "",
          },
          prices: {
            title: "How do we achieve those prices?",
            content: "",
          },
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
